import { types } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';

import { QuoteAllocationPriority } from '../definitions/InsCommon';
import { Event, IsoDate } from '../definitions/Common';
import Application from './Application';
import Metadata from './Metadata';


const InsCondoDocument = types
    .model('InsCondoDocument', {
        id: types.optional(types.identifier, () => uuid()),
        
        // These values are defaulted to the creation date and will
        // be automatically maintained/overwritten by the Profiles BE
        createdAt: types.maybe(IsoDate),
        updatedAt: types.maybe(IsoDate),
        userUpdatedAt:types.maybe(IsoDate),
        
        application: types.optional(Application, {}),
        metadata: types.optional(Metadata, {}),

        quoteAllocationPriorities: types.array(QuoteAllocationPriority),

        events: types.array(Event),

        schemaVersion: 1,
    })
    .actions(self => ({
        trackEvent({ type, details, metadata }) {
            if (!type) {
                throw new Error('Must specify an event type');
            }

            self.events.push({
                type,
                details,
                metadata,
            });
        },
        setAllocationPriorities(allocationPriorities) {
            self.quoteAllocationPriorities = allocationPriorities;
        },
        // This setter is used to set the application province state. The province
        // is used for routing and question determination. setting the province
        // here will override the address field from its previous state to ensure
        // we aren't created an invalid address
        setApplicationProvince(province) {
            self.application.property = {
                ...self.application.property,
                insuredAddress: {
                    province,
                },
            };
        },
    }));

export default InsCondoDocument;
